export default "__VITE_ASSET__BFKqYVg9__"